export default {
  outbound: 'Andata',
  inbound: 'Ritorno',
  hide: 'Nascondere',
  details: 'Mostra dettagli',
}
